import React from 'react'
import styled from 'styled-components'
import AssignmentHeader from './AssignmentHeader'
import DateCarousel from './DateCarousel'

const DateComponent = () => {
  const [zoomView, setZoomView] = React.useState(true)

  return (
    <Wrapper>
      <AssignmentHeader calendarView={zoomView} setCalendarView={setZoomView} />
      <DateCarousel />
    </Wrapper>
  )
}

export default DateComponent

const Wrapper = styled.div`
  width: 100%;
  gap: 20px;
  display: flex;
  flex-direction: column;
`
